import Splide from '@splidejs/splide';
import runBlazy from './utils/run-blazy';

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[data-door-tab]');
  const panels = document.querySelectorAll('[data-door-panel]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const activeTab = tab.dataset.doorTab;

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.doorPanel === activeTab;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
        if (isActive) panel.setAttribute('aria-labelledby', tab.id);
      });
    });
  });

  runBlazy();

  const initSplide = (selector, options) => {
    const element = document.querySelector(selector);
    if (!element) return;

    const splideInstance = new Splide(element, options);

    if (selector === '.mpDOF-body_video-list') {
      const prevMobile = document.querySelector('#splide-social-prev');
      const nextMobile = document.querySelector('#splide-social-next');

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'custom-nav-btn prev-btn';
      prevBtn.textContent = 'Prev';

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'custom-nav-btn next-btn';
      nextBtn.textContent = 'Next';

      const statusEl = element.querySelector('.pagination-status');
      const totalSlides = element.querySelectorAll('.splide__slide').length;

      const updateStatusText = (activeIndex) => {
        const currentPerPage = splideInstance.options.perPage;
        let start = activeIndex + 1;
        let end = activeIndex + currentPerPage;

        if (end > totalSlides) end = totalSlides;
        statusEl.textContent = `Showing ${start}-${end} of ${totalSlides} Video`;

        prevBtn.disabled = activeIndex === 0;
        nextBtn.disabled = end === totalSlides;
      };

      splideInstance.on('pagination:mounted', function (data) {
        data.items.forEach(function (item) {
          item.button.textContent = String(item.page + 1);
          item.button.classList.add('custom-page-item');
        });

        const paginationUl = data.list;

        paginationUl.prepend(prevBtn);
        paginationUl.append(nextBtn);
      });

      prevBtn.addEventListener('click', () => splideInstance.go('<'));
      prevMobile.addEventListener('click', () => splideInstance.go('<'));
      nextBtn.addEventListener('click', () => splideInstance.go('>'));
      nextMobile.addEventListener('click', () => splideInstance.go('>'));

      splideInstance.on('move', (newIndex) => {
        updateStatusText(newIndex);
      });

      splideInstance.on('mounted', () => {
        updateStatusText(0);
      });
    }

    return splideInstance.mount();
  };

  initSplide('#splide-pre-event-claim', {
    destroy: true,
    breakpoints: {
      480: {
        arrows: false,
        pagination: false,
        start: 0,
      },
    },
  });
  initSplide('#splide-main-event-claim', {
    destroy: true,
    breakpoints: {
      480: {
        arrows: false,
        pagination: false,
        start: 0,
      },
    },
  });
  initSplide('#splide-advanced-intelligence-lab', {
    destroy: true,
    breakpoints: {
      480: {
        arrows: false,
        pagination: false,
        start: 0,
      },
    },
  });
  initSplide('.mpDOF-body_video-list', {
    type: 'slide',
    perPage: 3,
    gap: '16px',
    arrows: false,
    drag: true,
    rewind: false,

    breakpoints: {
      768: {
        perPage: 2,
        gap: '12px',
        arrows: false,
      },
      480: {
        perPage: 1,
        focus: 'center',
        gap: '12px',
        padding: {
          left: '24px',
          right: '24px',
        },
      },
    },
  });
});
